import React, { useState } from 'react'
import { Grid, TextField, Button, Chip } from '@material-ui/core'
import { Edit, Check, Cancel } from '@material-ui/icons'

const ClarificationCategoryItem = ({ category, onEdit, onRemove }) => {
    const [editing, setEditing] = useState(false)
    const [editValue, setEditValue] = useState(category)

    const handleSave = () => {
        if (editValue.trim() && editValue !== category) {
            onEdit(category, editValue.trim())
        }
        setEditing(false)
        
    }

    const handleCancel = () => {
        setEditing(false)
        setEditValue(category)
    }

    if (editing) {
        return (
            <Grid container spacing={0} style={{ marginBottom: '0.5rem', alignItems: 'center' }}>
                <Grid item xs={12} sm={6} style={{backgroundColor: '#e1e1e1', minHeight: '48px', display: 'flex', alignItems: 'center', paddingLeft: '8px', borderRadius: '5px 0 0 5px'}}>
                    <TextField
                        fullWidth                        
                        size="small"
                        value={editValue}
                        onChange={e => setEditValue(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleSave()}
                    />
                </Grid>
                <Grid item style={{backgroundColor: '#e1e1e1', minHeight: '48px', display: 'flex', borderRadius: '0 5px 5px 0'}}>
                    <Button size="small" onClick={handleSave}>
                        <Check style={{color: '#05971a'}}/>
                    </Button>
                    <Button size="small" onClick={handleCancel}>
                        <Cancel style={{color: '#00000042'}}/>
                    </Button>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid container spacing={1} style={{ marginBottom: '0.5rem', alignItems: 'center' }}>
            <Grid item>
                <Chip 
                    label={category} 
                    variant="outlined"
                    onDelete={() => onRemove(category)}
                    style={{color:'#000000'}}
                />
            </Grid>
            <Grid item>
                <Button 
                    size="small" 
                    onClick={() => setEditing(true)}
                    startIcon={<Edit />}
                >
                    Edit
                </Button>
            </Grid>
        </Grid>
    )
}

export default ClarificationCategoryItem